module.exports = __webpack_public_path__ + "media/images/mailers/instagram-650c5954be88c41ea944efce92e9f57e.png";